import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { mixinBehaviors } from '@polymer/polymer/lib/legacy/class.js';
import { DefaultComputedBindings } from '../../modules/DefaultComputedBindings.js';
import { Debouncer } from '@polymer/polymer/lib/utils/debounce.js';
import '@polymer/paper-styles/color.js';
import '@polymer/paper-styles/shadow.js';
import '@polymer/iron-list/iron-list.js';
import '@polymer/paper-item/paper-item.js';
import '@polymer/paper-tooltip/paper-tooltip.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/iron-icons.js';
import './katapult-drop-down.js';
import '../katapult-elements/katapult-button.js';
import { ToArray } from '../../modules/ToArray.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { timeOut } from '@polymer/polymer/lib/utils/async.js';
/**
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
/* global k, CustomEvent, firebase */
class KatapultMultiDropDown extends mixinBehaviors([DefaultComputedBindings], PolymerElement) {
  static get template() {
    return html`
      <style>
        :host {
          position: relative;
          display: flex;
          align-items: center;

          --katapult-drop-down-font-size: 12pt;
          --katapult-drop-down-item-font-size: 12pt;
          --katapult-drop-down-slot-font-size: 11pt;
          --katapult-drop-down-color: transparent;

          --mobile-list-margin: 24px;
          --border-radius: 8px;
        }
        #inputWrapper {
          display: flex;
          align-items: center;
          flex-grow: 1;
        }
        #inputColumn {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        #floatedLabelPlaceholder {
          height: 20px;
        }
        #floatedLabelPlaceholder[with-spacing=''] {
          height: 42px;
        }
        #dataDisplay {
          display: flex;
          flex-direction: column;
        }
        #dataDisplay[inline=''] {
          flex-direction: row;
          flex-wrap: wrap;
        }
        #dataDisplay[drop-inline=''] {
          width: calc(100% - 24px);
          margin-top: 8px;
          margin-bottom: -30px;
        }
        #dataDisplay[drop-inline=''][overlaid=''] {
          margin-bottom: 0px;
        }
        #verticalSortContainer[dragging=''] {
          padding-top: 8px;
        }
        .dataItem {
          background-color: var(--paper-grey-200);
          border-radius: 999px;
          padding: 8px;
          margin-top: 8px;
          display: flex;
          justify-content: space-between;
          flex: 1;
          height: 100%;
        }
        .dataItem[inline=''] {
          flex: unset;
          margin: 4px 4px 0 0;
          font-size: 12px;
          z-index: 1;
          padding: 2px 4px;
          display: flex;
          align-items: center;
        }
        .dataItem katapult-button {
          padding: 0;
        }
        .dataItem.dragging {
          margin-top: 0;
        }
        [drag-handle]:hover {
          cursor: move;
        }
        #label {
          position: absolute;
          top: 0;
          left: 0;
          font: inherit;
          color: var(--paper-input-container-color, var(--secondary-text-color));
          transition:
            transform 0.25s,
            width 0.25s;
          transform-origin: left top;
          min-height: 1px;
          white-space: var(--paper-font-common-nowrap_-_white-space);
          overflow: var(--paper-font-common-nowrap_-_overflow);
          text-overflow: var(--paper-font-common-nowrap_-_text-overflow);
          font-family: var(--paper-font-subhead_-_font-family);
          -webkit-font-smoothing: var(--paper-font-subhead_-_-webkit-font-smoothing);
          font-weight: var(--paper-font-subhead_-_font-weight);
          line-height: var(--paper-font-subhead_-_line-height);
          font-size: var(--paper-input-container-label_-_font-size, var(--paper-font-subhead_-_font-size));
          transform: translateY(28px);
          pointer-events: none;
        }
        #label[floating=''] {
          width: 133%;
          transform: translateY(8px) scale(0.75);
        }
        #label[hide-on-float=''] {
          transform: translateY(8px);
        }
        #label[floating=''][hide-on-float=''] {
          display: none;
        }
      </style>

      <div id="inputWrapper">
        <div id="inputColumn">
          <template is="dom-if" if="[[!noLabelFloat]]">
            <div id="floatedLabelPlaceholder" with-spacing$="[[shouldAddSpacing(dataArray, searchText)]]"></div>
          </template>
          <div id="label" floating$="[[labelShouldFloat(dataArray, searchText)]]" hide-on-float$="[[noLabelFloat]]">[[label]]</div>
          <div
            id="dataDisplay"
            inline$="[[!displayVertically]]"
            drop-inline$="[[displayShouldDrop(dataArray, searchText, displayVertically)]]"
            overlaid$="[[overlay]]"
          >
            <!--Vertical, sortable display-->
            <template is="dom-if" if="[[displayVertically]]">
              <!--TODO: Fix styling quirks-->
              <paper-table-scroll id="verticalSortContainer" style="overflow: hidden" on-sort-changed="itemsSorted">
                <template is="dom-repeat" items="{{dataArray}}">
                  <paper-row slot="sortable" drag-handle class="dataItem">
                    <span>[[getDisplayLabel(item.$val, items)]]</span>
                    <katapult-button
                      size="[[if(displayVertically,'20','14')]]"
                      icon="clear"
                      iconOnly
                      noBorder
                      on-click="removeItem"
                    ></katapult-button>
                  </paper-row>
                </template>
              </paper-table-scroll>
            </template>
            <!--Inline display-->
            <template is="dom-if" if="[[!displayVertically]]">
              <template is="dom-repeat" items="{{dataArray}}">
                <div slot="sortable" class="dataItem" inline>
                  <span>[[getDisplayLabel(item.$val, items)]]</span>
                  <katapult-button icon="clear" iconOnly noBorder on-click="removeItem" hidden="[[disabled]]"></katapult-button>
                </div>
              </template>
            </template>
          </div>
          <!--TODO: Not sure what properties should be passed through to katapult-drop-down-->
          <katapult-drop-down
            id="dropdown"
            items="[[filteredItems]]"
            label-function="[[labelFunction]]"
            mobile="{{mobile}}"
            null-value=""
            search-text="{{searchText}}"
            fit-into="[[fitInto]]"
            label-path="[[labelPath]]"
            value-path="[[valuePath]]"
            display-shortname="[[displayShortname]]"
            invalid="[[invalid]]"
            disabled="[[disabled]]"
            no-label-float
            show-last-results="[[showLastResults]]"
            show-value-as-label="[[showValueAsLabel]]"
            only-open-down="[[onlyOpenDown]]"
            on-selected-will-change="addItem"
            readonly$="[[readonly]]"
            prefix-style="[[dropdownPrefixStyle]]"
            on-overlay-changed="setOverlay"
          >
            <slot></slot>
          </katapult-drop-down>
        </div>
      </div>
    `;
  }

  static get is() {
    return 'katapult-multi-drop-down';
  }
  static get properties() {
    return {
      /* Focus when attached */
      autoFocus: {
        type: Boolean,
        value: false
      },
      autoValidate: {
        type: Boolean,
        value: false
      },
      attributeName: {
        type: String,
        notify: true
      },
      disabled: {
        type: Boolean,
        value: false,
        notify: true,
        reflectToAttribute: true
      },
      displayShortname: {
        type: Boolean,
        value: false
      },
      externalChange: {
        type: Boolean,
        value: false
      },
      readonly: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      firebaseKey: {
        type: String,
        value: 'firebaseKey',
        notify: true
      },
      filteredSortedItems: {
        type: Array,
        value: () => [],
        notify: true
      },
      fixedListPosition: {
        type: Object,
        value: () => ({})
      },
      ironListItemsHeight: {
        type: Number,
        value: 0
      },
      hideEmptyListValue: {
        type: Boolean,
        value: false
      },
      icon: {
        type: String,
        value: null
      },
      keepOpen: {
        type: Boolean,
        value: false
      },
      label: {
        type: String,
        value: ''
      },
      labelForValue: {
        type: String,
        value: ''
      },
      labelFunction: {
        type: Function
      },
      labelPath: {
        type: String,
        value: ''
      },
      items: {
        notify: true
      },
      itemsArray: {
        type: Array,
        value: () => []
      },
      listHeight: {
        type: Number,
        value: null
      },
      listStyle: {
        type: String
      },
      log: {
        type: Boolean,
        value: false
      },
      margin: {
        type: Number,
        value: 24
      },
      minSearchLength: {
        type: Number,
        value: 0
      },
      /* force mobile view */
      mobile: {
        type: Boolean,
        value: false
      },
      noClear: {
        type: Boolean,
        value: false
      },
      noLabelFloat: {
        type: Boolean,
        value: false
      },
      /* force non-mobile view */
      noMobileView: {
        type: Boolean,
        value: false
      },
      invalid: {
        type: Boolean,
        value: false
      },
      showAllItems: {
        type: Boolean,
        value: false
      },
      secondaryLabelFunction: {
        type: Function
      },
      secondaryLabelPath: {
        type: String,
        value: ''
      },
      errorMessage: {
        type: String,
        value: ''
      },
      searchText: {
        type: String,
        value: '',
        notify: true
      },
      selectOnFocus: {
        type: Boolean,
        value: false
      },
      showLastResults: {
        type: Boolean,
        value: false
      },
      showValueAsLabel: {
        type: Boolean,
        value: false
      },
      sort: {
        type: Function,
        value: null
      },
      sortAlphabetically: {
        type: Boolean,
        value: false
      },
      value: {
        value: '',
        notify: true
      },
      valuePath: {
        type: String,
        value: ''
      },
      verticalOffset: {
        type: Number,
        value: 0
      },
      displayVertically: {
        type: Boolean,
        value: false
      },
      dataArray: {
        type: Array,
        value: () => []
      },
      allowDuplicates: {
        type: Boolean,
        value: false
      },
      filteredItems: {
        type: Array,
        computed: 'getFilteredItems(items, items.*, value, value.*, allowDuplicates)'
      },
      overlay: {
        type: Boolean,
        value: false
      },
      valueCanBeNull: {
        type: Boolean,
        value: false
      },
      displayLabel: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      countLimit: {
        type: Number,
        value: Infinity
      },
      seedValue: {
        type: String,
        value: ''
      }
    };
  }

  static get observers() {
    return [
      'setPrefixWidth(dataArray.*, displayVertically, overlay)',
      'valueChanged(value, value.*)',
      'updateValueWithSeed(items, seedValue)'
    ];
  }

  ready() {
    super.ready();
  }

  and() {
    return Array.from(arguments).every((x) => x);
  }

  equal(a, b) {
    return a === b;
  }

  focus() {
    this.$.dropdown.focus();
  }

  hasEntries(object) {
    if (Array.isArray(object)) return object.length > 0;
    else if (object) return Object.keys(object).length > 0;
    else return false;
  }

  labelShouldFloat() {
    return this.hasEntries(this.dataArray) || !!this.searchText;
  }

  shouldAddSpacing() {
    return !this.hasEntries(this.dataArray) && !!this.searchText;
  }

  displayShouldDrop() {
    return this.labelShouldFloat() && !this.displayVertically;
  }

  setOverlay(e) {
    this.set(`overlay`, e.currentTarget.hasAttribute('overlay'));
  }

  getFilteredItems() {
    // If duplicates are not allowed (default) and value is defined
    if (!this.allowDuplicates && this.value) {
      // Make a copy of the items array
      let items = JSON.parse(JSON.stringify(this.items || []));

      // Get the values currently selected and filter them from the items array, returning the result
      let currentValues = Array.isArray(this.value) ? this.value : Object.values(this.value);
      return items.filter((item) => !currentValues.includes(item[this.valuePath] ?? item));
    }

    // Otherwise, pass through the existing items array
    return this.items;
  }

  setPrefixWidth() {
    // Timeout allows dom changes to happen first
    setTimeout(() => {
      // If dropdown is not overlaid and shadow root is defined and we are displaying in line
      if (!this.overlay && this.shadowRoot && !this.displayVertically) {
        // Get the last data item element and the dropdown element
        let lastElement = this.shadowRoot.querySelector('.dataItem:last-of-type');
        let dropdownElement = this.shadowRoot.querySelector('#dropdown');
        // Set the width according to their bounding client rectangles
        if (lastElement && dropdownElement) {
          let width = lastElement.getBoundingClientRect().right - dropdownElement.getBoundingClientRect().left + 4;
          this.set(`dropdownPrefixStyle`, `width: ${width}px;`);
          return true;
        }
      }
      // Otherwise, set the style to empty
      this.set(`dropdownPrefixStyle`, '');
      return false;
    });
  }

  addItem(e) {
    // If there is a useful value
    if (![null, undefined, ''].includes(e.detail.value)) {
      // Cancel the selection to katapult drop down
      if (typeof e.composedPath == 'function') e.composedPath()[0].preventSelection = true;
      // Make sure that value is an object AND that there is not simply a placeholder empty value if value cannot be null: { -k000: '' }
      if (this.value !== null && typeof this.value == 'object' && !(!this.valueCanBeNull && Object.values(this.value)[0] == '')) {
        // If value is an array
        if (Array.isArray(this.value)) {
          this.push(`value`, e.detail.value);
        }
        // Otherwise, value is a javascript object
        else {
          // Generate sortable key, setting the sortable key based on the number of proper keys
          let numProperKeys = Object.keys(this.value).filter((item) => item.startsWith('-k')).length;
          let key = `-k${numProperKeys.toString(10).padStart(3, '0')}`;
          this.set(`value.${key}`, e.detail.value);
        }
      }
      // Otherwise, create an object
      else this.set(`value`, { '-k000': e.detail.value });
    }
    this.dispatchEvent(new CustomEvent('selected-changed', { detail: { value: this.value } }));
    // If the count is equal to or greater than the count limit, make the input read only
    if (Object.keys(this.value).length >= this.countLimit) this.$.dropdown.readonly = true;
  }

  removeItem(e) {
    // If value is an array
    if (Array.isArray(this.value)) {
      this.splice(`value`, e.model.index, 1);
    }
    // Otherwise, value is a javascript object
    else {
      let newValue = {};
      let counter = 0;
      // Loop through value and copy each item with the proper key except the deleted item
      for (const key in this.value) {
        if (key != e.model.item.$key && this.value[key] != null) {
          newValue[`-k${counter.toString(10).padStart(3, '0')}`] = this.value[key];
          counter += 1;
        }
      }
      // Set the last item to be null (representing the deleted item)
      newValue[`-k${counter.toString(10).padStart(3, '0')}`] = null;
      // If value cannot be null, set it to the placeholder empty value: { -k000: '' }
      if (!this.valueCanBeNull && Object.values(newValue)[0] == null) newValue['-k000'] = '';
      this.set(`value`, newValue);
      // TODO: Data problems when quickly deleting... modify dataArray and then LazySet the actual value
    }
    this.dispatchEvent(new CustomEvent('selected-changed', { detail: { value: this.value } }));
    // If the count is less than the count limit, update the input's readonly value
    if (Object.keys(this.value).length >= this.countLimit) this.$.dropdown.readonly = this.readonly;
  }

  itemsSorted(e) {
    // If the change matters
    if (e.detail.prevIndex != e.detail.index) {
      // Get the value array from the model
      let valueArray = this.dataArray.slice();
      // Splice the array to move the item
      let movedItem = valueArray.splice(e.detail.prevIndex, 1)[0];
      valueArray.splice(e.detail.index, 0, movedItem);
      // Create a new values object with the correct keys from the spliced array
      let values = {};
      for (const key in valueArray) {
        // Hanlde when value is an array and when it is an object
        let newKey = Array.isArray(this.value) ? key : `-k${key.toString(10).padStart(3, '0')}`;
        values[newKey] = valueArray[key].$val;
      }
      this.set(`value`, values);
    }
  }

  valueChanged(e) {
    // Set dataArray (which is the data displayed by the element) to the value, removing any blank keys
    this.set(
      `dataArray`,
      ToArray(this.value).filter((item) => item.$val)
    );
  }

  getDisplayLabel(val) {
    // Get the display label for the given value
    return this.displayLabel ? (this.items?.filter((item) => item[this.valuePath] == val)[0] || {})[this.labelPath] : val;
  }

  updateValueWithSeed() {
    // If items exists and the seed value exists and we don't already have a value, use the seed value
    if (this.items && this.seedValue && !this.value) this.addItem({ detail: { value: this.seedValue } });
  }
}

window.customElements.define(KatapultMultiDropDown.is, KatapultMultiDropDown);
